<template>
  <div class="ma-4">
    <!-- <v-dialog v-model="isDialogOpen">
      <v-card>
        <v-card-title class="headline">{{ dialogType }}</v-card-title>
        <v-divider />

        <v-card-text>
          <v-row dense>
            <v-col cols="6" v-if="currentEvent !== 'Criado'">
              <span class="text-h5 black--text">Antigo</span>
            </v-col>
            <v-col cols="6" v-if="currentEvent !== 'Deletado'">
              <span class="text-h5 black--text">Novo</span>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6" v-if="currentEvent !== 'Criado'">
              <Codemirror :value="oldValues" :options="cmOptions" />
            </v-col>
            <v-col cols="6" v-if="currentEvent !== 'Deletado'">
              <Codemirror :value="newValues" :options="cmOptions" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="isDialogOpen = false">Concluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="eventosAuditoria"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row align="center">
          <v-spacer />
          <v-col cols="4" class="mr-4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
        >
          <template v-slot:[`item.evento`]="{ item }">
            <div :class="`font-weight-bold ${colors[item.evento]}--text`">
              {{ item.evento }}
            </div>
          </template>
          <!-- <template v-slot:[`item.auditable_description`]="{ item }">
            <div class="tipo-evento">
              <span>{{ item.auditable_description }}</span>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    v-on="on"
                    v-bind="attrs"
                    @click="handleOpenDialog(item.old_values, item.new_values, item.evento)"
                  >
                    <v-icon small color="bluePcm">mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalhes</span>
              </v-tooltip>
            </div>
          </template> -->
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Eventos encontrados: {{ qtdEventos }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
// import { codemirror } from 'vue-codemirror'

import ListPagination from '@/componentes/ListPagination'

import 'codemirror/theme/duotone-light.css'
import 'codemirror/mode/javascript/javascript.js'
import '../../../../PABX/modules/configuracoes/modules/webhooks/_styles/codemirror.css'

export default {
  props: {
    eventosAuditoria: Array,
  },
  components: { ListPagination },
  // components: { ListPagination, Codemirror: codemirror },
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    page: 1,
    showSkeleton: false,
    itemsPerPage: 20,
    search: '',
    namespaces: {
      AlliasRegex: 'Expressão Regular',
      Audio: 'Áudio',
      CentroDeCusto: 'Centro de Custo',
      Conferencia: 'Conferência',
      Config: 'Configuração',
      Facilidade: 'Facilidade',
      Grupo: 'Grupos',
      MusicaDeEspera: 'Música de Espera',
      Ramais: 'Ramais',
      Rota: 'Rota',
      Tags: 'Tags',
      Troncos: 'Troncos',
      Tarefas: 'Tarefas',
      Ura: 'Ura',
      Agente: 'Agente',
      Pause: 'Pausa',
      WebHook: 'Webhook',
      Queue: 'Fila',
      Pesquisa: 'Pesquisa',
      Role: 'Perfil',
      User: 'Usuário',
      Departamento:'Departamento',
      Tronco:'Tronco',
      ConfigCallCenter: 'Configuração Monitor',
      PjsipTransport: 'Transport',
    },
    colors: {
      Criado: 'green',
      Atualizado: 'bluePcm',
      Deletado: 'red',
    },
    headers: [
      { text: 'Data/Hora', value: 'data', align: 'left' },
      { text: 'IP', value: 'ip_address', align: 'left', sortable: false },
      { text: 'Usuário', value: 'user', align: 'left' },
      { text: 'Evento', value: 'evento', align: 'left', sortable: false },
      { text: 'Tipo', value: 'auditable_type', align: 'left', sortable: false },
      { text: 'Descrição', value: 'auditable_description', align: 'left', sortable: false },
    ],
    isDialogOpen: false,
    oldValues: '',
    newValues: '',
    currentEvent: '',
    cmOptions: {
      tabSize: 2,
      mode: 'text/javascript',
      theme: 'duotone-light',
      json: true,
      lineNumbers: false,
      line: true,
      readOnly: true,
    },
  }),

  computed: {
    qtdEventos() {
      return this.eventosAuditoria.length
    },
    numberOfPages() {
      return Math.ceil(this.eventosAuditoria.length / this.itemsPerPage)
    },
  },

  methods: {
    handleOpenDialog(oldValues, newValues, evento) {
      this.oldValues = JSON.stringify(oldValues, null, 2)
      this.newValues = JSON.stringify(newValues, null, 2)
      this.currentEvent = evento
      this.isDialogOpen = true
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) {
        this.page += 1
        this.$router.push({ query: { page: this.page } })
      }
    },
    formerPage() {
      if (this.page - 1 >= 1) {
        this.page -= 1
        this.$router.push({ query: { page: this.page } })
      }
    },
    firstPage() {
      if (this.page > 1) {
        this.page = 1
        this.$router.push({ query: { page: this.page } })
      }
    },
    lastPage() {
      if (this.page < this.numberOfPages) {
        this.page = this.numberOfPages
        this.$router.push({ query: { page: this.page } })
      }
    },
  },
}
</script>

<style scoped>
.tipo-evento {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
</style>
